import angular from 'angular';
import connectIncomeEmployment from './connectIncomeEmployment';

export default angular
  .module('financials.connectIncomeEmployment', [])
  .component('connectIncomeEmployment', connectIncomeEmployment).name;
